import { render, staticRenderFns } from "./compare_drivers.vue?vue&type=template&id=c9d139d2&"
import script from "./compare_drivers.vue?vue&type=script&lang=js&"
export * from "./compare_drivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports